import { Action, State } from './types'

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'OPEN_LETTER_OF_CONSENT':
      return {
        isOpen: true,
        hotelId: action.payload.hotelId,
      }
    case 'CLOSE_LETTER_OF_CONSENT':
      return {
        isOpen: false,
        hotelId: null,
      }
    default:
      return state
  }
}

export default reducer
